import moment, { Moment } from "moment"

const combineDateAndTime = (dateStr: string, timeStr: string) => {
  const datePart = dateStr.split("T")[0]
  const timePart = timeStr.split("T")[1]
  const combinedDateTimeStr = `${datePart}T${timePart}`
  return new Date(combinedDateTimeStr)
}

function parseDateWithFallback(
  date: string | Date | Moment | undefined | number,
  fallback = "1970-01-01",
) {
  const momentDate = moment(date)

  if (typeof date === "string" && date?.length === 10) {
    return momentDate
  }

  if (momentDate.isValid()) {
    return momentDate
  } else {
    return moment(fallback)
  }
}

export { combineDateAndTime, parseDateWithFallback }
